export class CategoriaModel {
    constructor(
        public id_categoria: number,
        public id_departamento: number,
        public nombre_categoria: string      
    ) { }
}